module.exports = __webpack_public_path__ + "static/media/50_A.740e1705.png";